var map = {
	"../info/info.module": [
		"./src/app/info/info.module.ts",
		"default~admin-admin-module~base-base-module~covid-covid-module~info-info-module",
		"default~admin-admin-module~covid-covid-module~info-info-module",
		"common",
		"info-info-module"
	],
	"./admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		"default~admin-admin-module~base-base-module~covid-covid-module~info-info-module",
		"default~admin-admin-module~covid-covid-module~info-info-module",
		"common",
		"admin-admin-module"
	],
	"./base/base.module": [
		"./src/app/base/base.module.ts",
		"default~admin-admin-module~base-base-module~covid-covid-module~info-info-module",
		"common",
		"base-base-module"
	],
	"./covid/covid.module": [
		"./src/app/covid/covid.module.ts",
		"default~admin-admin-module~base-base-module~covid-covid-module~info-info-module",
		"default~admin-admin-module~covid-covid-module~info-info-module",
		"common",
		"covid-covid-module"
	],
	"./info/info.module": [
		"./src/app/info/info.module.ts",
		"default~admin-admin-module~base-base-module~covid-covid-module~info-info-module",
		"default~admin-admin-module~covid-covid-module~info-info-module",
		"common",
		"info-info-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;